(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hab-brand-import-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hab-location-delivery')) {
    customElements.define('hab-location-delivery', class extends HTMLElement {
      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('[data-delivery-source]')).map(panel => ({
          panel,
          variants: JSON.parse(panel.dataset.variantIds)
        }));
        this.scope = this.closest('.hab-pdp-buy, .product-single__meta') || this.parentElement;
        this.refresh = () => {
          const input = this.scope.querySelector('form[action*="/cart/add"] [name="id"]');
          const id = input ? input.value : this.dataset.initialVariant;
          if (id === this.currentVariant) return;
          this.currentVariant = id;
          this.panels.forEach(({ panel, variants }) => { panel.hidden = !variants.includes(id); });
        };
        this.refresh();
        this.timer = setInterval(this.refresh, 250);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
